import { getTimes, isDescendant } from './utils.js'

export default function createTimebox ($toggle, { onClose = () => {} } = {}) {
  let enabled = true
  let isOpen = false
  let id = $toggle.getAttribute('data-list')
  let $listContainer = document.getElementById(id)
  let $lists = $listContainer.querySelectorAll('ul')
  let $input = document.getElementById($toggle.getAttribute('data-input'))
  let $selectedOption
  let $am = $lists[0]
  let $pm = $lists[1]

  $toggle.setAttribute('aria-haspopup', 'listbox')
  $listContainer.setAttribute('tabindex', '-1')
  $listContainer.setAttribute('role', 'listbox')

  function createOption (acc, curr, idx) {
    return `${acc}<li class="flex-none w-1/4 px-2 mt-2 cursor-pointer" id="${id}-${idx}" role="option"><span class="block bg-grey-lighter hover:bg-yellow transition-bg" style="padding:0.5em;">${curr.replace(
      /^0/,
      ''
    )}</span></li>`
  }

  $am.innerHTML = getTimes(5, 12).reduce(createOption, '')
  $pm.innerHTML = getTimes(12, 18.1).reduce(createOption, '')

  $listContainer.addEventListener('click', e => {
    if (!enabled) return
    let $option = e.target.closest('li')
    if (!$option) return

    $listContainer.setAttribute('aria-activedescendant', $option.id)

    if ($selectedOption) {
      $selectedOption.removeAttribute('aria-selected')
    }

    $option.setAttribute('aria-selected', 'true')
    let val = $option.getAttribute('data-value')
    if ($input) {
      $input.value = val === null ? $option.textContent : val
    }

    $toggle.textContent = `Arrival Time: ${$option.getAttribute('data-label') ||
      $option.textContent}`

    $selectedOption = $option

    if ($listContainer.scrollHeight > $listContainer.clientHeight) {
      let scrollBottom = $listContainer.clientHeight + $listContainer.scrollTop
      let elementBottom =
        $selectedOption.offsetTop + $selectedOption.offsetHeight
      if (elementBottom > scrollBottom) {
        $listContainer.scrollTop = elementBottom - $listContainer.clientHeight
      } else if ($selectedOption.offsetTop < $listContainer.scrollTop) {
        $listContainer.scrollTop = $selectedOption.offsetTop
      }
    }

    close()
  })

  $toggle.addEventListener('click', onclick)

  function onclick () {
    if (!enabled) return
    $listContainer.hidden = !$listContainer.hidden
    isOpen = !$listContainer.hidden

    if ($listContainer.hidden) {
      $toggle.removeAttribute('aria-expanded')

      window.removeEventListener('focus', closeOnBlur)
      window.removeEventListener('click', closeOnBlur)
    } else {
      $toggle.setAttribute('aria-expanded', 'true')

      if (
        $selectedOption &&
        $listContainer.scrollHeight > $listContainer.clientHeight
      ) {
        let elementMiddle =
          $selectedOption.offsetTop + $selectedOption.offsetHeight / 2
        $listContainer.scrollTop =
          elementMiddle - $listContainer.clientHeight / 2
      }

      $listContainer.focus()

      window.addEventListener('focus', closeOnBlur, true)
      window.addEventListener('click', closeOnBlur)
    }
  }

  function closeOnBlur (e) {
    if (
      e.target !== $listContainer &&
      e.target !== $toggle &&
      !isDescendant($listContainer, e.target) &&
      !isDescendant($toggle, e.target)
    ) {
      close()
    }
  }

  function close () {
    if (!isOpen) return
    $listContainer.hidden = true
    isOpen = false
    $toggle.removeAttribute('aria-expanded')
    window.removeEventListener('focus', closeOnBlur)
    window.removeEventListener('click', closeOnBlur)
    onClose(api)
  }

  let api = {
    $list: $listContainer,
    getValue () {
      return $input.value
    },
    disable () {
      enabled = false
      $input.setAttribute('readonly', '')
      $toggle.disabled = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/_timebox.js